import { render } from "./RelateDialog.vue?vue&type=template&id=3c60f673"
import script from "./RelateDialog.vue?vue&type=script&lang=js"
export * from "./RelateDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\Account\\web\\Medical-Account-Web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__